const isUnauthorized = response => response && response.status === 401;
const isNotFound = response => response && response.status === 404;

export {
    isUnauthorized,
    isNotFound,
};
